import { css } from '@emotion/core'

export const styles = {
  input: css`
    border: none;
    outline: none;

    background: rgba(242, 241, 238, 0.6);
    box-shadow: rgba(15, 15, 15, 0.1) 0px 0px 0px 1px inset,
      rgba(15, 15, 15, 0.1) 0px 1px 1px inset;
    border-radius: 3px;
    color: rgb(4, 4, 4);

    &::placeholder {
      color: rgb(156, 156, 156);
    }

    &:disabled {
      opacity: 0.5;
    }

    height: 35px;
    padding: 0 10px;
    &:not(:first-child) {
      margin-top: 12px;
    }

    font-size: 14px;
  `,

  disabled: css`
    opacity: 0.75;
  `,

  withLabel: {
    container: css`
      display: flex;
      flex-direction: column;

      &:not(:first-child) {
        margin-top: 18px;
      }
    `,

    label: css`
      font-size: 12px;
      text-transform: uppercase;
      font-weight: 600;
      user-select: none;
    `,

    required: css`
      font-size: 10px;
      color: #c0392b;
      opacity: 0.75;

      vertical-align: text-top;
      line-height: 150%;
    `,

    input: css`
      margin-top: 8px !important;
    `,
  },

  select: {
    container: css`
      color: rgb(156, 156, 156);
      cursor: pointer;
    `,

    selected: css`
      color: rgb(4, 4, 4);
    `,
  },
}
